(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["haletern-header"]) return;
  try {
    
  if (!customElements.get('haletern-announcement')) {
    class HaleternAnnouncement extends HTMLElement {
      connectedCallback() {
        if (this.toggleButton) return;
        this.toggleButton = this.querySelector('.ht-announcement__toggle');
        if (!this.toggleButton) return;
        this.motionPreference = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.viewport = this.querySelector('.ht-announcement__viewport');
        this.toggleMotion = () => {
          if (this.motionPreference.matches) return;
          const paused = this.dataset.paused !== 'true';
          this.dataset.paused = String(paused);
          this.toggleButton.setAttribute('aria-label', paused ? this.toggleButton.dataset.resumeLabel : this.toggleButton.dataset.pauseLabel);
        };
        this.updateMotionPreference = () => {
          this.toggleButton.hidden = this.motionPreference.matches;
        };
        this.toggleButton.addEventListener('click', this.toggleMotion);
        this.viewport?.addEventListener('click', this.toggleMotion);
        this.motionPreference.addEventListener('change', this.updateMotionPreference);
        this.updateMotionPreference();
        this.dataset.ready = 'true';
      }
      disconnectedCallback() {
        this.toggleButton?.removeEventListener('click', this.toggleMotion);
        this.viewport?.removeEventListener('click', this.toggleMotion);
        this.motionPreference?.removeEventListener('change', this.updateMotionPreference);
        delete this.dataset.ready;
        this.toggleButton = null;
        this.viewport = null;
      }
    }
    customElements.define('haletern-announcement', HaleternAnnouncement);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["haletern-range-home"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('haletern-range-home')) {
    customElements.define('haletern-range-home', class extends HTMLElement {
      connectedCallback() {
        if (this.openFormula) return;
        this.openFormula = async (event) => {
          const opener = event.target.closest('[data-range-home-open]');
          if (!opener || !this.contains(opener)) return;
          const range = this.querySelector('haletern-range');
          if (!range) return;
          await customElements.whenDefined('haletern-range');
          if (!this.isConnected || !opener.isConnected) return;
          const dialog = range.querySelector('#' + CSS.escape(opener.dataset.rangeHomeOpen));
          if (!dialog || dialog.open) return;
          event.preventDefault();
          range.openers.set(dialog, opener);
          dialog.showModal();
        };
        this.addEventListener('click', this.openFormula);
      }
      disconnectedCallback() {
        this.removeEventListener('click', this.openFormula);
        this.openFormula = null;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["haletern-supplement"]) return;
  try {
    
if(!customElements.get('haletern-supplement')){
  customElements.define('haletern-supplement',class extends HTMLElement{
    connectedCallback(){
      if(this.boundClick)return;
      this.boundClick=(event)=>{
        const opener=event.target.closest('[data-supplement-label-open]');
        if(opener&&this.contains(opener)){
          const dialog=this.querySelector('#'+CSS.escape(opener.dataset.supplementLabelOpen));
          if(dialog&&!dialog.open){
            event.preventDefault();
            this.lastOpener=opener;
            const image=dialog.querySelector('[data-supplement-label-image]');
            if(!image.getAttribute('src'))image.src=image.dataset.labelSrc;
            dialog.showModal();
            this.setLabelZoom(dialog,100);
          }
          return;
        }
        const zoom=event.target.closest('[data-supplement-label-zoom]');
        if(zoom){
          const dialog=zoom.closest('dialog');
          const current=Number(dialog.dataset.zoom||100);
          this.setLabelZoom(dialog,zoom.dataset.supplementLabelZoom==='fit'?100:current+(zoom.dataset.supplementLabelZoom==='in'?50:-50));
          return;
        }
        const closer=event.target.closest('[data-supplement-label-close]');
        if(closer){closer.closest('dialog').close();return;}
        if(event.target.tagName==='DIALOG'){
          const rect=event.target.getBoundingClientRect();
          if(event.clientX<rect.left||event.clientX>rect.right||event.clientY<rect.top||event.clientY>rect.bottom)event.target.close();
        }
      };
      this.boundClose=()=>this.lastOpener?.focus();
      this.addEventListener('click',this.boundClick);
      this.querySelector('dialog')?.addEventListener('close',this.boundClose);
      this.boundResize=()=>{
        const dialog=this.querySelector('dialog[open]');
        if(dialog)this.setLabelZoom(dialog,Number(dialog.dataset.zoom||100));
      };
      window.addEventListener('resize',this.boundResize);
    }
    setLabelZoom(dialog,value){
      const zoom=Math.max(100,Math.min(600,value));
      const viewport=dialog.querySelector('.ht-supplement__label-viewport');
      const image=dialog.querySelector('[data-supplement-label-image]');
      const viewportStyle=getComputedStyle(viewport);
      const dialogStyle=getComputedStyle(dialog);
      const pixels=value=>Number.parseFloat(value)||0;
      const horizontalInset=pixels(viewportStyle.paddingLeft)+pixels(viewportStyle.paddingRight)+pixels(viewportStyle.borderLeftWidth)+pixels(viewportStyle.borderRightWidth);
      const verticalInset=pixels(viewportStyle.paddingTop)+pixels(viewportStyle.paddingBottom)+pixels(viewportStyle.borderTopWidth)+pixels(viewportStyle.borderBottomWidth);
      const dialogInset=dialogStyle.boxSizing==='border-box'?pixels(dialogStyle.paddingTop)+pixels(dialogStyle.paddingBottom)+pixels(dialogStyle.borderTopWidth)+pixels(dialogStyle.borderBottomWidth):0;
      const dialogBudget=(pixels(dialogStyle.maxHeight)||window.innerHeight)-dialogInset;
      const otherHeight=Array.from(dialog.children).filter(child=>child!==viewport).reduce((height,child)=>{
        const style=getComputedStyle(child);
        return height+child.getBoundingClientRect().height+pixels(style.marginTop)+pixels(style.marginBottom);
      },0);
      const viewportLimit=(pixels(viewportStyle.maxHeight)||dialogBudget)+(viewportStyle.boxSizing==='content-box'?verticalInset:0);
      const availableHeight=Math.max(1,Math.min(viewportLimit,dialogBudget-otherHeight)-verticalInset);
      const availableWidth=Math.max(1,viewport.getBoundingClientRect().width-horizontalInset);
      const imageWidth=Number(image.getAttribute('width'))||image.naturalWidth;
      const imageHeight=Number(image.getAttribute('height'))||image.naturalHeight;
      const aspect=imageWidth>0&&imageHeight>0?imageWidth/imageHeight:1;
      const fitWidth=Math.min(availableWidth,availableHeight*aspect);
      dialog.dataset.zoom=String(zoom);
      image.style.width=Math.max(1,Math.floor(fitWidth*zoom/100))+'px';
      dialog.querySelector('[data-supplement-label-level]').value=zoom+'%';
      dialog.querySelector('[data-supplement-label-zoom="out"]').disabled=zoom===100;
      dialog.querySelector('[data-supplement-label-zoom="in"]').disabled=zoom===600;
      if(zoom===100)viewport.scrollTo(0,0);
    }
    disconnectedCallback(){
      this.removeEventListener('click',this.boundClick);
      this.querySelector('dialog')?.removeEventListener('close',this.boundClose);
      window.removeEventListener('resize',this.boundResize);
      this.boundClick=null;
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
